/* Setzt die Bestellnummer aus ?ref= ein. Laeuft nur auf der Danke-Seite. */
(function () {
  // Die Bestellnummer kommt als ?ref=WZ-XXXXXXXX von Stripe zurueck.
  // Streng validieren: Was hier ungeprueft ins DOM geht, ist eine
  // Einladung, dem Kunden fremde Inhalte auf unserer Seite zu zeigen.
  var ref = new URLSearchParams(window.location.search).get('ref') || '';
  if (!/^WZ-[A-Z0-9]{6,12}$/.test(ref)) return;
  var el = document.getElementById('wz-ref');
  var box = document.getElementById('wz-ref-box');
  if (!el || !box) return;
  el.textContent = ref;
  box.hidden = false;
})();